module.exports = __webpack_public_path__ + "img/tatars-DE.a193a72a.png";